export default "__VITE_PUBLIC_ASSET__a2762fb0__"